module.exports = __webpack_public_path__ + "img/colorful-char1.55a162ef.png";